import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../shared/storage/firebase';

// Define a basic structure for a question.
// This can be expanded as needed.
export interface FormQuestion {
  id: string;
  type: string;
  label: string;
  required?: boolean;
  [key: string]: any; // For other properties like 'options', 'placeholder', etc.
}

export interface FormConfiguration {
  name: string;
  version: string;
  questions: FormQuestion[];
}

export const useFormConfiguration = (formVersion: string) => {
  const [formConfig, setFormConfig] = useState<FormConfiguration | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      if (!formVersion) {
        setLoading(false);
        return;
      }
      
      setLoading(true);
      try {
        const formRef = doc(db, 'formConfigurations', formVersion);
        const docSnap = await getDoc(formRef);

        if (docSnap.exists()) {
          setFormConfig(docSnap.data() as FormConfiguration);
        } else {
          setError(new Error(`Form configuration '${formVersion}' not found.`));
        }
      } catch (err) {
        setError(err instanceof Error ? err : new Error('An unknown error occurred'));
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, [formVersion]);

  return { formConfig, loading, error };
}; 